export default {
    computed: {
        cur_customer() {
            return this.$store.state.cur_customer
          },
        is_financer_stock() {
            return this.diffGroup('GROUP_STOCK_FIN')
          },
          is_store() {
            return this.diffGroup('GROUP_STOCK_MALL')
          },
          is_agreement() {
            return this.diffGroup('GROUP_STOCK_SCM')
          },   
    },
    methods: {
        diffGroup(g) {
          return this.cur_customer && this.cur_customer.groups && this.cur_customer.groups.includes(g)
        },
    }   
}